import React from "react";
import { Component, Fragment } from "react";

import {
	Card,
	CardBody,
	CardTitle,
	Col,
	Row,
	Input,
	ListGroup,
	ListGroupItem,
	Button,
	ButtonGroup,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	ButtonDropdown,
	Tooltip
} from 'reactstrap';

import { Line, Bar } from 'react-chartjs-2';
import Chart from 'react-c3-component';
import 'c3/c3.css';
import Moment from 'moment';
import { DASHBOARD_POLL_INTERVAL_MS } from '../../dashboard/product-filter';
import DashboardCardLoader from '../../dashboard/dashboard-card-loader';
var moment = require('moment-timezone');

class UserPowerSettings extends React.Component {

	noResults = true;
	intervalID = 0;
	dataRequestID = 0;

	constructor(props) {
    super(props);
    this.state = {
			rSelected: 3,
			power: '',
			noDevices: false,
			noDataForDevices: false,
			currentDataSetting: 0,
			startDate: Moment().subtract(5, 'year').format('YYYY-MM-DD'),
			endDate: Moment().format('YYYY-MM-DD'),
			currentDate: Moment().format('YYYY-MM-DD'),
			isOpen: false,
			currentItem: "Global",
			tooltipOpen: false,
			deviceList: JSON.parse(localStorage.getItem('deviceList')),
			currentUser: JSON.parse(localStorage.getItem('currentUser')),
			isLoading: true
	  };

		this.onRadioBtnClick = this.onRadioBtnClick.bind(this);
		this.toggleDropDown = this.toggleDropDown.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);

		this.toggleTooltip = this.toggleTooltip.bind(this);
  }

	async componentDidMount() {
		// if (this.state.currentUser.payload["custom:role"] && this.state.currentUser.payload["custom:role"]>0) {
		// 	this.selectDropDownItem(2, "Week");
		// }

	 	//this.getData();
		setTimeout(this.getData, this.props.loadDelay || 0);
		this.intervalID = setInterval(()=>{ this.getData(); }, DASHBOARD_POLL_INTERVAL_MS);
	}

	toggleTooltip() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

	toggleDropDown() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

	handleChange(event) {
		if (event.target.getAttribute('name') == 'startDate') {
			this.setState({
				startDate: event.target.value,
				currentItem: "Custom",
				currentDataSetting: 4
			}, this.getData);
		} else if (event.target.getAttribute('name') == 'endDate') {
			//console.log('this.state.code: ' + event.target.value);
			this.setState({
				endDate: event.target.value,
				currentItem: "Custom",
				currentDataSetting: 4
			}, this.getData);
		}
  }

	handleSubmit(event) {

		this.getData();
  }

	selectDropDownItem(id, title) {
		let startDate = this.state.startDate;

		if (id==0) {
			startDate = Moment().subtract(5, 'year').format('YYYY-MM-DD');
		} else if (id==1) {
			startDate = Moment().format('YYYY-MM-DD');
		} else if (id==2) {
			startDate = Moment().subtract(1, 'week').format('YYYY-MM-DD');
		} else if (id==3) {
			startDate = Moment().subtract(1, 'month').format('YYYY-MM-DD');
		} else if (id==4) {
			startDate = Moment().subtract(1, 'month').format('YYYY-MM-DD');
		}

		this.setState({
			currentItem: title,
			currentDataSetting: id,
			startDate,
			endDate: Moment().format('YYYY-MM-DD'),
			isLoading: true,
			power: '',
			noDataForDevices: false
		}, this.getData);
  }

	componentWillUnmount() {
		//console.log("UserPowerSettings componentWillUnmount");
		clearInterval(this.intervalID);
	}

  onRadioBtnClick(rSelected) {
    this.setState({ rSelected });
		this.getData(rSelected);
  }

	stepBack () {
		if (this.state.currentDataSetting==1) {
			let revisedStartDate = Moment(this.state.startDate).subtract(1, 'day').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).subtract(1, 'day').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate, endDate: revisedEndDate, isLoading: true }, this.getData);
		} else if (this.state.currentDataSetting==2) {
			let revisedStartDate = Moment(this.state.startDate).subtract(1, 'week').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).subtract(1, 'week').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate, endDate: revisedEndDate, isLoading: true }, this.getData);
		} else if (this.state.currentDataSetting==3) {
			let revisedStartDate = Moment(this.state.startDate).subtract(1, 'month').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).subtract(1, 'month').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate, endDate: revisedEndDate, isLoading: true }, this.getData);
		}
	}

	stepForward () {
		if (this.state.currentDataSetting==1) {
			let revisedStartDate = Moment(this.state.startDate).add(1, 'day').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).add(1, 'day').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate, endDate: revisedEndDate, isLoading: true }, this.getData);
		} else if (this.state.currentDataSetting==2) {
			let revisedStartDate = Moment(this.state.startDate).add(1, 'week').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).add(1, 'week').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate, endDate: revisedEndDate, isLoading: true }, this.getData);
		} else if (this.state.currentDataSetting==3) {
			let revisedStartDate = Moment(this.state.startDate).add(1, 'month').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).add(1, 'month').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate, endDate: revisedEndDate, isLoading: true }, this.getData);
 	 	}
	}

	getData = async () => {

		const requestID = ++this.dataRequestID;
		this.setState({ isLoading: true });
		var timezone = Moment.tz.guess();

		console.log("Start Date: " + JSON.stringify(this.state.startDate));
		console.log("End Date: " + JSON.stringify(this.state.endDate));

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"used-power-settings-for-device-date-range?SerialNumber="+this.props.currentDevice+"&StartDate="+this.state.startDate+"&EndDate="+this.state.endDate+"&Timezone="+timezone;
		console.log("used-power-settings date range url: " + url);

		var token = "";

		if (this.props.authToken) {
			console.log("laser-usage this.props.authToken: " + this.props.authToken);
			token = this.props.authToken;
		}

		try {
			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: token
				},
			});

			const body = await response.json();
			console.log("usedpowersettings date range body response: " + JSON.stringify(body));
			if (requestID !== this.dataRequestID) {
				return;
			}

			if (body.status == 'Success') {
				if (body.results.length>0) {
					let powerAvg = parseFloat(body.results[0].power, 10)/10;
					let roundedPower = powerAvg.toFixed(1)
					this.setState({ power: roundedPower, noDataForDevices: false }, () => console.log(this.state.power));
				} else {
					this.setState({ noDataForDevices: true });
				}
			} else {
				this.setState({ noDataForDevices: true });
			}
		}
		catch (err) {
			console.log(err);
		}
		finally {
			if (requestID === this.dataRequestID) {
				this.setState({ isLoading: false });
			}
		}

	}

	render() {
		return (
      <Card className="card-hover">
				<CardBody style={{ minHeight: 250 }}>
				<Row>
					<Col xs="6" md="9" lg="9" className="text-left">
						<CardTitle>Most Used Manual Power Settings
						<i style={{color: '#ffffff'}} className="mdi mdi-information-outline ml-1" id="MUMPSTooltip"/>
						<Tooltip placement="top" isOpen={this.state.tooltipOpen} target="MUMPSTooltip" toggle={this.toggleTooltip}>
							Shows the most-used average power setting in manual mode for the desired time period. Does not include any data from preset settings.
						</Tooltip>
						</CardTitle>
					</Col>
					<Col xs="6" md="3" lg="3" className="text-right">
						<ButtonDropdown isOpen={this.state.isOpen} toggle={this.toggleDropDown}>
							<DropdownToggle color="dark" caret>
								{this.state.currentItem}
							</DropdownToggle>
							<DropdownMenu right>
								<DropdownItem onClick={() => this.selectDropDownItem(0, 'Global')}>Global</DropdownItem>
								<DropdownItem onClick={() => this.selectDropDownItem(1, 'Today')}>Today</DropdownItem>
								<DropdownItem onClick={() => this.selectDropDownItem(2, 'Week')}>Week</DropdownItem>
								<DropdownItem onClick={() => this.selectDropDownItem(3, 'Month')}>Month</DropdownItem>
								<DropdownItem onClick={() => this.selectDropDownItem(4, 'Custom')}>Custom</DropdownItem>
							</DropdownMenu>
						</ButtonDropdown>
					</Col>
				</Row>
					{
					// <Row>
					// 	<Col xs="12" md="12" lg="12">
					// 		<div className="mt-1 mb-2">
					// 			<ButtonGroup style={{ width: '100%' }}>
					// 				<Button
					// 					style={{width: '100%'}}
					// 					color="dark"
					// 					onClick={() => this.onRadioBtnClick(1)}
					// 					active={this.state.rSelected === 1}
					// 				>
					// 					Today
					// 				</Button>
					// 				<Button
					// 					color="dark"
					// 					style={{width: '100%'}}
					// 					onClick={() => this.onRadioBtnClick(2)}
					// 					active={this.state.rSelected === 2}
					// 				>
					// 					This Week
					// 				</Button>
					// 				<Button
					// 					color="dark"
					// 					style={{width: '100%'}}
					// 					onClick={() => this.onRadioBtnClick(3)}
					// 					active={this.state.rSelected === 3}
					// 				>
					// 					This Month
					// 				</Button>
					// 			</ButtonGroup>
					// 		</div>
					// 	</Col>
					// </Row>
					}
					<div className="pt-3 pb-4">
						{this.state.currentDataSetting != 0 && this.state.currentDataSetting != 4 ? (
							<Row className="align-items-center">
								<div style={{ width: '10%', margin: '0 auto', height: '100%' }}>
									<Button size="sm" color="link" onClick={() => this.stepBack()} title="Vitals">
										<i style={{color: '#b3b5bb'}} className="mdi mdi-arrow-left mdi-24px"/>
									</Button>
								</div>
								<div style={{ width: '80%', margin: '0 auto', height: '100%' }}>
									<div className="mt-5 mb-3 text-center">
										{this.state.isLoading ? (
											<DashboardCardLoader />
										) : this.state.noDevices || this.state.noDataForDevices ? (
											<Fragment>
											{!this.state.noDataForDevices &&
												<h2 style={{color:'#e9c736'}}>No results Found</h2>
											}
											{this.state.noDataForDevices &&
												<h2 style={{color:'#e9c736'}}>No results Found</h2>
											}
											</Fragment>
										) : null}
										{!this.state.isLoading && !this.state.noDevices && !this.state.noDataForDevices &&
											<h2 style={{color:'#e9c736'}}>{this.state.power} Watts</h2>
										}
									</div>
								</div>
								<div style={{ width: '10%', margin: '0 auto', height: '100%' }}>
									<Button size="sm" color="link" disabled={this.state.currentDate==this.state.endDate} onClick={() => this.stepForward()} title="Vitals">
										<i style={{color: '#b3b5bb'}} className="mdi mdi-arrow-right mdi-24px"/>
									</Button>
								</div>
							</Row>
						) : (
							<Fragment>
								<div className="mt-5 mb-3 text-center">
									{this.state.isLoading ? (
										<DashboardCardLoader />
									) : this.state.noDevices || this.state.noDataForDevices ? (
										<Fragment>
										{!this.state.noDataForDevices &&
											<h2 style={{color:'#e9c736'}}>No results Found</h2>
										}
										{this.state.noDataForDevices &&
											<h2 style={{color:'#e9c736'}}>No results Found</h2>
										}
										</Fragment>
									) : null}
									{!this.state.isLoading && !this.state.noDevices && !this.state.noDataForDevices &&
										<h2 style={{color:'#e9c736'}}>{this.state.power} Watts</h2>
									}
								</div>
							</Fragment>
						)}
					</div>
					{this.state.currentDataSetting != 0 &&
					<Row className="mt-2">
						<Col lg="12" xl="6" className="text-right">
							{this.state.currentDataSetting == 1 ? (
								<div className="float-left" style={{ minWidth: '10%' }}>
									<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>Day:</h6>
								</div>
							) : (
								<div className="float-left" style={{ minWidth: '10%' }}>
									<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>From:</h6>
								</div>
							)}
							<div className="float-left ml-1" style={{ minWidth: '75%' }}>
								<Input style={{ minWidth: '135px' }} name='startDate' size='sm' type="date" value={this.state.startDate} onChange={this.handleChange} />
							</div>
						</Col>
						<Col lg="12" xl="6" className="">
							{this.state.currentDataSetting != 1 &&
								<Fragment>
								<div className="float-left text-right" style={{ minWidth: '10%' }}>
									<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>To:</h6>
								</div>
								<div className="float-left ml-1" style={{ minWidth: '75%' }}>
									<Input style={{ minWidth: '135px' }} name='endDate' size='sm' type="date" value={this.state.endDate} onChange={this.handleChange} />
								</div>
								</Fragment>
							}
							{
								// <div className="float-left ml-1" style={{ minWidth: '16%' }}>
								// 	<Button size="sm" color="dark" onClick={() => this.handleSubmit()} title="Vitals" disabled={this.state.currentDataSetting != 4}>
								// 		GO
								// 	</Button>
								// </div>
							}
						</Col>
					</Row>
					}
        </CardBody>
      </Card>
		);
	}
}

export default UserPowerSettings;
